<template>
  <div class="scrollable-wrapper">
    <div
      ref="scrollbar"
      class="scrollbar"
      :style="`height: ${height};max-height: ${maxHeight};`"
      @scroll="onScrollY"
    >
      <slot />
    </div>
  </div>
</template>
<script>
import { Debouncer } from '../../services/debouncer';

export default {
  name: 'NativeScrollableContent',
  props: {
    height: {
      type: String,
      default: '100%',
    },
    maxHeight: {
      type: String,
      default: '100%',
    },
    scrollEventDebounceMs: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      debouncer: new Debouncer(this.emitScrollYEvent, this.scrollEventDebounceMs, true),
    };
  },
  methods: {
    onScrollY() {
      this.debouncer.execute();
    },
    emitScrollYEvent() {
      this.$emit('onScrollY');
    },
  },
};
</script>

<style scoped>
.scrollable-wrapper {
  width: 100%;
  min-width: 0;
  flex-grow: 1;
}

.scrollbar {
  overflow-y: auto;
}
</style>
